import MessagesFilters from './MessagesFilters/MessagesFilters'

import { joinClassNames } from '../../../utils/styles'
import styles from './messages-header.module.scss'

interface IMessagesHeaderProps {
    className?: string
}

function MessagesHeader(props: IMessagesHeaderProps) {
    const { className } = props

    return (
        <nav className={joinClassNames(className, styles.messagesHeader)}>
            <MessagesFilters />
        </nav>
    )
}

export default MessagesHeader
